export default __webpack_public_path__ + "static/thumb-bpress-stainless-steel-a9c14c53d8ca555fd5050d1ac0ba82f9.jpg";